import React from 'react';
import LegalContentLayout from '../components/common/Legal/LegalContentLayout';

const Terms = () => <LegalContentLayout contentKey="terms" />;

export default Terms;
